import { useTranslation } from "react-i18next";
import { useAppStore } from "../lib/store";
import { getThemeColors } from "../lib/theme";

interface GameLoadingScreenProps {
  message?: string;
  showGrid?: boolean;
}

export function GameLoadingScreen({
  message,
  showGrid = true,
}: GameLoadingScreenProps) {
  const { t } = useTranslation();
  const isDark = useAppStore((state) => state.isDark);
  const theme = getThemeColors(isDark);

  return (
    <div
      className={`min-h-screen ${theme.bg} flex items-center justify-center font-sans relative`}
    >
      {showGrid && (
        <div className="absolute inset-0 opacity-[0.03]">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
              linear-gradient(${isDark ? "#fff" : "#000"} 1px, transparent 1px),
              linear-gradient(90deg, ${isDark ? "#fff" : "#000"} 1px, transparent 1px)
            `,
              backgroundSize: "60px 60px",
            }}
          />
        </div>
      )}

      <div className="relative flex flex-col items-center gap-4">
        <div className="relative">
          <div
            className={`w-12 h-12 rounded-full border-2 ${isDark ? "border-zinc-800 border-t-zinc-400" : "border-gray-200 border-t-gray-500"} animate-spin`}
          />
        </div>
        <span
          className={`text-xs font-mono uppercase tracking-widest ${theme.textMuted}`}
        >
          {message ?? t("components.loadingScreen")}
        </span>
      </div>
    </div>
  );
}
